export default __webpack_public_path__ + "static/media/544.595be09f.png";